import UserLayout from './UserLayout.jsx'

export default UserLayout
